import { AccordionPanel } from '../components/jdsaccordion/generated';
import { ActionButton } from '../components/jdsactionbutton/generated';
import { Avatar } from '../components/jdsavatar/generated';
import { AvatarV2 } from '../components/jdsavatarv2/generated';
import { AvatarV2CompleteRing } from '../components/jdsavatarv2completering/generated';
import { AvatarV2Default } from '../components/jdsavatarv2default/generated';
import { AvatarV2Information } from '../components/jdsavatarv2information/generated';
import { AvatarV2Notification } from '../components/jdsavatarv2notification/generated';
import { AvatarV2ProgressRing } from '../components/jdsavatarv2progressring/generated';
import { AvatarV2SegmentedRing } from '../components/jdsavatarv2segmentedring/generated';
import { AvatarV2Status } from '../components/jdsavatarv2status/generated';
import { Badge } from '../components/jdsbadge/generated';
import { BadgeV2 } from '../components/jdsbadgev2/generated';
import { BadgeV2Brand } from '../components/jdsbadgev2brand/generated';
import { BadgeV2Information } from '../components/jdsbadgev2information/generated';
import { BadgeV2Notification } from '../components/jdsbadgev2notification/generated';
import { BadgeV2Status } from '../components/jdsbadgev2status/generated';
import { BottomFooter } from '../components/jdsbottomfooter/generated';
import { BottomFooterLinkItem } from '../components/jdsbottomfooterlinkitem/generated';
import { BottomNavigationItem } from '../components/jdsbottomnavigationitem/generated';
import { BottomSheet } from '../components/jdsdesktopbottomsheet/generated';
import { Button } from '../components/jdsbutton/generated';
import { CarouselPagination } from '../components/jdscarouselpagination/generated';
import { CarouselPaginationItem } from '../components/jdscarouselpaginationitem/generated';
import { CarouselSlide } from '../components/jdscarouselslide/generated';
import { ContentBlock } from '../components/jdscontentblock/generated';
import { DatePicker } from '../components/jdsdatepickerdesktop';
import { DatepickerButton } from '../components/jdsdatepickerbutton/generated';
import { DatepickerCalendar } from '../components/jdsdatepickercalendar/generated';
import { DatepickerCalendarButton } from '../components/jdsdatepickercalendarbutton/generated';
import { DatepickerCalendarHeader } from '../components/jdsdatepickercalendarheader/generated';
import { DatepickerCalendarRow } from '../components/jdsdatepickercalendarrow/generated';
import { DatepickerDesktopInternal } from '../components/jdsdatepickerdesktopinternal/generated';
import { DatepickerHeader } from '../components/jdsdatepickerheader/generated';
import { DatepickerMonthView } from '../components/jdsdatepickermonthview/generated';
import { DatepickerViewButton } from '../components/jdsdatepickerviewbutton/generated';
import { DatepickerYearView } from '../components/jdsdatepickeryearview/generated';
import { DesktopBottomSheetInternal } from '../components/jdsdesktopbottomsheetinternal/generated';
import { Divider } from '../components/jdsdivider/generated';
import { DropdownMenu } from '../components/jdsdropdownmenu/generated';
import { DropdownMenuGroup } from '../components/jdsdropdownmenugroup/generated';
import { DropdownMenuInternal } from '../components/jdsdropdownmenuinternal/generated';
import { DropdownMenuItem } from '../components/jdsdropdownmenuitem/generated';
import { DropdownMenuSubMenu } from '../components/jdsdropdownmenusubmenu/generated';
import { DropdownMenuSubMenuInternal } from '../components/jdsdropdownmenusubmenuinternal/generated';
import { FAB } from '../components/jdsfab/generated';
import { FABInternal } from '../components/jdsfabinternal/generated';
import { FeedbackBlock } from '../components/jdsfeedbackblock/generated';
import { FileUploaderControl } from '../components/jdsfileuploadercontrol/generated';
import { FileUploaderItem } from '../components/jdsfileuploaderitem/generated';
import { FileUploaderList } from '../components/jdsfileuploaderlist/generated';
import { FileUploaderPanel } from '../components/jdsfileuploaderpanel/generated';
import { FooterIconLinks } from '../components/jdsfootericonlinks/generated';
import { FooterLinks } from '../components/jdsfooterlinks/generated';
import { FooterLinksGrid } from '../components/jdsfooterlinksgrid/generated';
import { FooterMarketLinks } from '../components/jdsfootermarketlinks/generated';
import { Header } from '../components/jdsheaderdesktop/generated';
import { HorizontalStepItem } from '../components/jdshorizontalstepitem/generated';
import { Icon } from '../components/jdsicon/generated';
import { Image } from '../components/jdsimage/generated';
import { Input } from '../components/jdsinput/generated';
import { InputCheckbox } from '../components/jdscheckbox/generated';
import { InputCodeItem } from '../components/jdsinputcodeitem/generated';
import { InputPhoneDropdown } from '../components/jdsinputphonedropdown/generated';
import { Link } from '../components/jdslink/generated';
import { ListBlock } from '../components/jdslistblock/generated';
import { MegaMenu } from '../components/jdsmegamenu/generated';
import { MegaMenuBlock } from '../components/jdsmegamenublock/generated';
import { MegaMenuInternal } from '../components/jdsmegamenuinternal/generated';
import { MegaMenuItem } from '../components/jdsmegamenuitem/generated';
import { MenuBlock } from '../components/jdsmenublock/generated';
import { MenuBlockInternal } from '../components/jdsmenublockinternal/generated';
import { MenuBlockItem } from '../components/jdsmenublockitem/generated';
import { MobileBottomSheetInternal } from '../components/jdsmobilebottomsheetinternal/generated';
import { Modal } from '../components/jdsmodaldesktop/generated';
import { ModalDesktopInternal } from '../components/jdsmodaldesktopinternal/generated';
import { ModalMobileInternal } from '../components/jdsmodalmobileinternal/generated';
import { NotificationButton } from '../components/jdsnotificationbutton/generated';
import { Nudge } from '../components/jdsnudge/generated';
import { PaginationButton } from '../components/jdspaginationbutton/generated';
import { ProgressBar } from '../components/jdsprogressbar/generated';
import { RatingBarItem } from '../components/jdsratingbaritem/generated';
import { SearchBox } from '../components/jdssearchbox/generated';
import { SearchResults } from '../components/jdssearchresults/generated';
import { SearchResultsInternal } from '../components/jdssearchresultsinternal/generated';
import { SearchResultItem as SearchResultsItem } from '../components/jdssearchresultitem/generated';
import { SearchResultText as SearchResultsText } from '../components/jdssearchresulttext/generated';
import { SegmentedRingItem } from '../components/jdssegmentedringitem/generated';
import { SelectorButton } from '../components/jdsselectorbutton/generated';
import { SelectorItem } from '../components/jdsselectoritem/generated';
import { SidePanelInternal } from '../components/jdssidepanelinternal/generated';
import { SidePanelItem } from '../components/jdssidepanelitem/generated';
import { Skeleton } from '../components/jdsskeleton/generated';
import { Spinner } from '../components/jdsspinner/generated';
import { StepperDot } from '../components/jdsstepperdot/generated';
import { TabBar } from '../components/jdstabbar/generated';
import { TabItem } from '../components/jdstabitem/generated';
import { TableBody } from '../components/jdstablebody/generated';
import { TableCell } from '../components/jdstablecell/generated';
import { TableRow } from '../components/jdstablerow/generated';
import { Tabs } from '../components/jdstabsdesktop/generated';
import { Text } from '../components/jdstext/generated';
import { Toast } from '../components/jdstoast/generated';
import { Tooltip } from '../components/jdstooltip/generated';
import { TooltipInternal } from '../components/jdstooltipinternal/generated';
import { VerticalStepItem } from '../components/jdsverticalstepitem/generated';

export const componentsMap: Record<string, () => React.FC<any>> & {
  slotName?: string;
} = {
  jds_text: () => Text,
  jds_icon: () => Icon,
  jds_skeleton: () => Skeleton,
  jds_badge: () => Badge,
  jds_toast: () => Toast,
  jds_nudge: () => Nudge,
  jds_fab: () => FAB,
  jds_fab_internal: () => FABInternal,
  jds_selector_item: () => SelectorItem,
  jds_table_cell: () => TableCell,
  jds_table_row: () => TableRow,
  jds_table_body: () => TableBody,
  jds_selector_button: () => SelectorButton,
  jds_menu_block_item: () => MenuBlockItem,
  jds_notification_button: () => NotificationButton,
  jds_action_button: () => ActionButton,
  jds_tab_item: () => TabItem,
  jds_feedback_block: () => FeedbackBlock,
  jds_link: () => Link,
  jds_bottom_footer_link_item: () => BottomFooterLinkItem,
  jds_bottom_sheet: () => BottomSheet,
  jds_desktop_bottom_sheet_internal: () => DesktopBottomSheetInternal,
  jds_mobile_bottom_sheet_internal: () => MobileBottomSheetInternal,
  jds_divider: () => Divider,
  jds_image: () => Image,
  jds_footer_links: () => FooterLinks,
  jds_footer_icon_links: () => FooterIconLinks,
  jds_footer_market_links: () => FooterMarketLinks,
  jds_footer_links_grid: () => FooterLinksGrid,
  jds_bottom_footer: () => BottomFooter,
  jds_content_block: () => ContentBlock,
  jds_search_result_item: () => SearchResultsItem,
  jds_search_results_internal: () => SearchResultsInternal,
  jds_avatar: () => Avatar,
  jds_segmented_ring_item: () => SegmentedRingItem,
  jds_avatar_v2: () => AvatarV2,
  jds_avatar_v2_segmented_ring: () => AvatarV2SegmentedRing,
  jds_avatar_v2_progress_ring: () => AvatarV2ProgressRing,
  jds_avatar_v2_complete_ring: () => AvatarV2CompleteRing,
  jds_avatar_v2_default: () => AvatarV2Default,
  jds_avatar_v2_information: () => AvatarV2Information,
  jds_avatar_v2_status: () => AvatarV2Status,
  jds_avatar_v2_notification: () => AvatarV2Notification,
  jds_button: () => Button,
  jds_accordion: () => AccordionPanel,
  jds_mega_menu_item: () => MegaMenuItem,
  jds_mega_menu_block: () => MegaMenuBlock,
  jds_search_box: () => SearchBox,
  jds_modal_desktop_internal: () => ModalDesktopInternal,
  jds_modal_mobile_internal: () => ModalMobileInternal,
  jds_modal_desktop: () => Modal,
  jds_side_panel_item: () => SidePanelItem,
  jds_side_panel_internal: () => SidePanelInternal,
  jds_header: () => Header,
  jds_mega_menu: () => MegaMenu,
  jds_bottom_navigation_item: () => BottomNavigationItem,
  jds_carousel_pagination_item: () => CarouselPaginationItem,
  jds_carousel_pagination: () => CarouselPagination,
  jds_carousel_slide: () => CarouselSlide,
  jds_datepicker_button: () => DatepickerButton,
  jds_datepicker_calendar_button: () => DatepickerCalendarButton,
  jds_datepicker_view_button: () => DatepickerViewButton,
  jds_datepicker_calendar_row: () => DatepickerCalendarRow,
  jds_datepicker_calendar: () => DatepickerCalendar,
  jds_datepicker_year_view: () => DatepickerYearView,
  jds_datepicker_calendar_header: () => DatepickerCalendarHeader,
  jds_datepicker_header: () => DatepickerHeader,
  jds_datepicker_month_view: () => DatepickerMonthView,
  jds_dropdown_menu_item: () => DropdownMenuItem,
  jds_dropdown_menu_group: () => DropdownMenuGroup,
  jds_dropdown_menu: () => DropdownMenu,
  jds_dropdown_menu_submenu: () => DropdownMenuSubMenu,
  jds_dropdown_menu_sub_menu_internal: () => DropdownMenuSubMenuInternal,
  jds_dropdown_menu_internal: () => DropdownMenuInternal,
  jds_pagination_button: () => PaginationButton,
  jds_datepicker: () => DatePicker,
  jds_datepicker_desktop_internal: () => DatepickerDesktopInternal,
  jds_datepicker_mobile_internal: () => DatepickerDesktopInternal,
  jds_menu_block: () => MenuBlock,
  jds_menu_block_internal: () => MenuBlockInternal,
  jds_list_block: () => ListBlock,
  jds_input: () => Input,
  jds_input_code_item: () => InputCodeItem,
  jds_tab_bar: () => TabBar,
  jds_search_results: () => SearchResults,
  jds_search_result_text: () => SearchResultsText,
  jds_stepper_dot: () => StepperDot,
  jds_step_item_vertical: () => VerticalStepItem,
  jds_step_item_horizontal: () => HorizontalStepItem,
  jds_spinner: () => Spinner,
  jds_tooltip: () => Tooltip,
  jds_tooltip_internal: () => TooltipInternal,
  jds_checkbox: () => InputCheckbox,
  swadesh_checkbox: () => InputCheckbox,
  swadesh_text: () => Text,
  // jds_swadesh_media: () => SwadeshMedia,
  // swadesh_button: () => SwadeshButton,
  // swadesh_search_result_item: () => SwadeshSearchResultItem,
  // jds_swadesh_button: () => SwadeshButton,
  jds_rating_bar_item: () => RatingBarItem,
  jds_file_uploader_control: () => FileUploaderControl,
  jds_file_uploader_panel: () => FileUploaderPanel,
  jds_file_uploader_item: () => FileUploaderItem,
  jds_file_uploader_list: () => FileUploaderList,
  jds_progress_bar: () => ProgressBar,
  jds_input_phone_dropdown: () => InputPhoneDropdown,
  jds_badge_v2: () => BadgeV2,
  jds_badge_v2_status: () => BadgeV2Status,
  jds_badge_v2_information: () => BadgeV2Information,
  jds_badge_v2_notification: () => BadgeV2Notification,
  jds_badge_v2_brand: () => BadgeV2Brand,
  jds_tabs_desktop: () => Tabs,
  jds_megamenu_internal: () => MegaMenuInternal
  // add more components as we keep adding newer ones
};
